export interface Comic {
  id: string;
  title: string;
  author: string;
  genre: string;
  tags: string[];
  rating: number;
  popularity: number;
  status: string;
  chapters: number;
  year: string;
  cover: string;
  summary: string;
  intro: string;
  highlights: string[];
}

export const comics: Comic[] = [
  {
    id: 'rebirth-star',
    title: '重生之我被顶流告白了',
    author: '金秀贤（改编）',
    genre: '都市恋爱',
    tags: ['重生', '甜宠', '娱乐圈'],
    rating: 9.6,
    popularity: 98,
    status: '连载中',
    chapters: 128,
    year: '2023',
    cover: 'https://readdy.ai/api/search-image?query=romance%20webtoon%20manhwa%20book%20cover%20illustration%2C%20young%20female%20lead%20and%20male%20celebrity%20in%20city%20night%2C%20warm%20pink%20and%20coral%20palette%2C%20vibrant%20digital%20painting%2C%20clean%20soft%20background%2C%20dynamic%20composition&width=600&height=800&seq=comic-01&orientation=portrait',
    summary: '前世被背叛的女主重生回到五年前，这一次她选择主动靠近那位未来的顶流巨星。',
    intro: '26岁的造型师林初夏在一场车祸后重生成18岁的自己。前世她看着心爱的男神在聚光灯下闪耀却始终不敢靠近，这一世她决定主动出击。当冷傲顶流顾景行一次次被她"无意间"的贴心打动，一段甜到发齁的都市恋曲就此展开。细腻的少女心事与娱乐圈浮沉交织，画风清丽，糖分十足。',
    highlights: ['重生逆袭设定爽感十足', '顶流男主反差萌人设', '每周双更高甜剧情'],
  },
  {
    id: 'dark-knight',
    title: '黑暗骑士的契约',
    author: '朴正浩',
    genre: '奇幻战斗',
    tags: ['黑暗奇幻', '契约', '热血'],
    rating: 9.4,
    popularity: 96,
    status: '连载中',
    chapters: 96,
    year: '2022',
    cover: 'https://readdy.ai/api/search-image?query=dark%20fantasy%20webtoon%20manhwa%20book%20cover%20illustration%2C%20armored%20knight%20with%20glowing%20sword%20against%20night%20sky%2C%20moody%20crimson%20and%20charcoal%20tones%2C%20epic%20digital%20art%2C%20clean%20dark%20background&width=600&height=800&seq=comic-02&orientation=portrait',
    summary: '落魄骑士与古神签订契约，以寿命为代价换取力量，踏上一场复仇与守护的征途。',
    intro: '王国覆灭之夜，年轻骑士艾德温失去了一切。绝望之际，他被封印千年的古神选中，以三分之一寿命换来"弑神之力"。每一次挥剑都在燃烧生命，他必须在力量耗尽前找出王国覆灭的真相。宏大的世界观、畅快的战斗分镜与反转不断的剧情，被誉为近年最硬核的韩式暗黑奇幻。',
    highlights: ['宏大世界观与史诗叙事', '契约设定脑洞大开', '分镜充满张力'],
  },
  {
    id: 'after-school-magic',
    title: '放学后的魔法少女',
    author: '李多恩',
    genre: '校园魔幻',
    tags: ['魔法', '校园', '治愈'],
    rating: 9.1,
    popularity: 88,
    status: '已完结',
    chapters: 152,
    year: '2021',
    cover: 'https://readdy.ai/api/search-image?query=cute%20school%20fantasy%20webtoon%20manhwa%20cover%20illustration%2C%20teenage%20magical%20girl%20with%20sparkling%20wand%20at%20school%20sunset%2C%20soft%20lavender%20and%20peach%20palette%2C%20clean%20dreamy%20background&width=600&height=800&seq=comic-03&orientation=portrait',
    summary: '平凡女高中生放学后意外获得魔法力量，在守护校园与守护日常之间摇摆的治愈冒险。',
    intro: '高二学生尹智妍只是个普通女孩，直到某天放学后，她捡到一本会说话的魔法书。从那以后，每到黄昏她都会变身成"魔法少女"，替同学们实现愿望。看似轻松的故事背后，藏着关于成长、友谊与告别的温柔内核。画风清新治愈，是许多读者的入坑之作。',
    highlights: ['单元剧结构节奏轻快', '治愈系画风赏心悦目', '结局催泪收束'],
  },
  {
    id: 'chaebol-maid',
    title: '财阀家的佣人',
    author: '郑瑞英',
    genre: '职场现实',
    tags: ['财阀', '逆袭', '职场'],
    rating: 8.9,
    popularity: 85,
    status: '连载中',
    chapters: 110,
    year: '2022',
    cover: 'https://readdy.ai/api/search-image?query=modern%20drama%20webtoon%20manhwa%20book%20cover%2C%20young%20woman%20in%20uniform%20inside%20luxury%20mansion%2C%20warm%20golden%20and%20cream%20tones%2C%20elegant%20digital%20painting%2C%20clean%20soft%20background&width=600&height=800&seq=comic-04&orientation=portrait',
    summary: '为还清家庭债务进入财阀宅邸当佣人的女主，在尔虞我诈中步步为营、逆风翻盘。',
    intro: '家境破碎的韩素妍为了替母亲还债，隐姓埋名进入韩国顶级财阀朴氏宅邸当佣人。她凭借过人的观察力与韧性，在宅邸的权力漩涡中巧妙周旋，也逐渐揭开财阀家族隐藏的秘密。现实感极强的职场博弈与爽快逆袭，让这部作品话题度居高不下。',
    highlights: ['财阀内斗看点十足', '女主清醒独立大女主', '职场爽文天花板'],
  },
  {
    id: 'seoul-survival',
    title: '丧尸时代：首尔求生',
    author: '崔真源',
    genre: '末日生存',
    tags: ['丧尸', '末世', '群像'],
    rating: 9.2,
    popularity: 93,
    status: '连载中',
    chapters: 84,
    year: '2023',
    cover: 'https://readdy.ai/api/search-image?query=apocalypse%20survival%20webtoon%20manhwa%20book%20cover%2C%20survivor%20group%20running%20through%20ruined%20seoul%20street%20at%20dusk%2C%20gritty%20red%20and%20dark%20amber%20palette%2C%20dynamic%20digital%20art&width=600&height=800&seq=comic-05&orientation=portrait',
    summary: '丧尸病毒爆发后的首尔，一群性格迥异的幸存者抱团求生，在人性与生存间艰难抉择。',
    intro: '疫情失控的第三天，整座首尔沦为死城。工程师金道允带着弟弟与几名陌生人组成求生小队，从地下商场一路向郊外撤离。宏大的生存群像、逼真的末世氛围与直击人性弱点的剧情，让读者在紧张刺激中持续追更。每一话都在拷问：活下去的代价是什么？',
    highlights: ['紧张刺激的求生节奏', '群像刻画真实立体', '人性主题发人深省'],
  },
  {
    id: 'moon-swordsman',
    title: '月下剑客',
    author: '姜武赫',
    genre: '古风武侠',
    tags: ['武侠', '复仇', '美学'],
    rating: 9.5,
    popularity: 91,
    status: '连载中',
    chapters: 120,
    year: '2020',
    cover: 'https://readdy.ai/api/search-image?query=historical%20wuxia%20webtoon%20manhwa%20cover%2C%20lone%20swordsman%20under%20full%20moon%20on%20mountain%20ridge%2C%20ink%20wash%20and%20vermilion%20accents%2C%20poetic%20digital%20painting%2C%20clean%20misty%20background&width=600&height=800&seq=comic-06&orientation=portrait',
    summary: '背负灭门之仇的少年剑客，在乱世中以一人一剑丈量江湖恩怨与道义。',
    intro: '十年前，白月山庄一夜覆灭，独子沈剑离背负血海深仇踏上寻仇之路。十年后，他以"月下剑客"之名行走江湖，却在一次对决中窥见当年惨案背后的更大阴谋。作品以水墨般的意境、行云流水的武打分镜和深厚的东方美学，被许多读者奉为韩漫武侠标杆。',
    highlights: ['东方水墨美学极致', '武打分镜行云流水', '家国情怀格局宏大'],
  },
  {
    id: 'love-with-ai',
    title: '我和AI谈恋爱的日子',
    author: '裴珠贤',
    genre: '科幻恋爱',
    tags: ['科幻', 'AI', '治愈'],
    rating: 8.8,
    popularity: 82,
    status: '已完结',
    chapters: 74,
    year: '2021',
    cover: 'https://readdy.ai/api/search-image?query=scifi%20romance%20webtoon%20manhwa%20cover%2C%20girl%20and%20glowing%20holographic%20ai%20companion%20at%20night%20apartment%2C%20cool%20teal%20and%20warm%20orange%20glow%2C%20clean%20minimal%20background&width=600&height=800&seq=comic-07&orientation=portrait',
    summary: '独居女程序员购买了一台陪伴型AI，却发现自己渐渐对它产生了超出预期的情感。',
    intro: '习惯独来独往的程序员姜诗雅，为了解决深夜无人倾诉的寂寞，购入了一台人形陪伴AI"Luna"。本以为是单纯的智能助手，却在日复一日的相处中，发现它的"关心"越来越像一个真实的人。当AI开始拥有自我意识，这段跨越物种的感情该何去何从？',
    highlights: ['概念新颖引人深思', '情感刻画细腻', '结局留白余韵悠长'],
  },
  {
    id: 'chef-bistro',
    title: '厨神小餐馆',
    author: '黄敏珍',
    genre: '美食日常',
    tags: ['美食', '治愈', '日常'],
    rating: 9.0,
    popularity: 86,
    status: '连载中',
    chapters: 140,
    year: '2019',
    cover: 'https://readdy.ai/api/search-image?query=cozy%20food%20webtoon%20manhwa%20cover%2C%20warm%20little%20restaurant%20kitchen%20with%20steaming%20delicious%20dishes%2C%20golden%20and%20cream%20palette%2C%20heartwarming%20digital%20painting%2C%20clean%20warm%20background&width=600&height=800&seq=comic-08&orientation=portrait',
    summary: '前米其林主厨在巷口开了一家平价小餐馆，用一道菜治愈一座城的人心。',
    intro: '曾经叱咤米其林的后厨天才朴大厨，一夜之间销声匿迹，转头在首尔老城区巷口开了一家只有八个座位的"深夜小餐馆"。每天限量供应三道菜，却让无数食客排队三小时。每个看似平凡的故事背后，都藏着一段与食物有关的旧时光与和解。美食与温情并存，越看越饿。',
    highlights: ['深夜食堂式治愈', '美食画面垂涎欲滴', '单元故事温暖动人'],
  },
  {
    id: 'galaxy-mercenary',
    title: '星际雇佣兵',
    author: '安世元',
    genre: '科幻冒险',
    tags: ['星际', '冒险', '爽文'],
    rating: 9.3,
    popularity: 95,
    status: '连载中',
    chapters: 68,
    year: '2024',
    cover: 'https://readdy.ai/api/search-image?query=space%20adventure%20webtoon%20manhwa%20book%20cover%2C%20mercenary%20pilot%20with%20mech%20against%20galaxy%20and%20planets%2C%20vivid%20red%20orange%20and%20navy%20palette%2C%20epic%20clean%20space%20background&width=600&height=800&seq=comic-09&orientation=portrait',
    summary: '被逐出军队的精英驾驶员辗转成为星际雇佣兵，在银河乱局中重铸荣耀与自由。',
    intro: '王牌驾驶员李澈因背锅被军队除名，为了活下去他成了一名接单看心情的星际雇佣兵。从护送走私客到星际佣兵团大战，他在一次次任务中结识伙伴、揭开宇宙深处的秘密。节奏明快、机战热血的宇宙冒险，搭配流畅的科技画风，爽点密集。',
    highlights: ['星际机战场面震撼', '爽文节奏一路高能', '团队群像各有魅力'],
  },
  {
    id: 'campus-ghost',
    title: '校园十大灵异事件',
    author: '孙泰亨',
    genre: '灵异悬疑',
    tags: ['灵异', '校园', '悬疑'],
    rating: 8.7,
    popularity: 79,
    status: '已完结',
    chapters: 96,
    year: '2020',
    cover: 'https://readdy.ai/api/search-image?query=horror%20mystery%20webtoon%20manhwa%20cover%2C%20dark%20empty%20school%20corridor%20with%20ghostly%20figure%20and%20moonlight%2C%20muted%20blue%20and%20deep%20shadow%20palette%2C%20eerie%20clean%20background&width=600&height=800&seq=comic-10&orientation=portrait',
    summary: '流传已久的校园灵异传说竟一一成真，灵研社成员在破解谜团时触碰真相禁区。',
    intro: '成均高校流传着"十大灵异事件"，本以为是无聊的校园传说，却在毕业季逐一应验。好奇心旺盛的灵研社五人组开始调查，却发现每一起灵异事件背后，都指向十五年前一桩被掩埋的旧案。层层反转的悬疑设计、恰到好处的惊悚氛围，让你欲罢不能。',
    highlights: ['单元+主线双线叙事', '悬念设置环环相扣', '惊悚氛围拿捏到位'],
  },
  {
    id: 'courier-superpower',
    title: '快递小哥的超能力日常',
    author: '曹智恩',
    genre: '热血搞笑',
    tags: ['超能力', '搞笑', '都市'],
    rating: 9.0,
    popularity: 90,
    status: '连载中',
    chapters: 132,
    year: '2022',
    cover: 'https://readdy.ai/api/search-image?query=action%20comedy%20webtoon%20manhwa%20book%20cover%2C%20happy%20delivery%20courier%20boy%20with%20superpower%20glow%20in%20city%2C%20bright%20orange%20and%20yellow%20palette%2C%20playful%20clean%20background&width=600&height=800&seq=comic-11&orientation=portrait',
    summary: '一名普通快递员意外觉醒超能力，从此在送快递和拯救城市之间来回横跳。',
    intro: '快递员王满仓在派件途中被雷劈中，意外觉醒了"瞬间移动"的超能力。本想着用来刷派件绩效、提前下班，却总被卷入奇奇怪怪的都市事件。能力越强、麻烦越大，他在笑料百出的日常里，逐渐担起守护街坊的责任。轻松搞笑又带燃点，下饭神作。',
    highlights: ['无厘头笑点密集', '草根英雄接地气', '搞笑中带燃点'],
  },
  {
    id: 'reversal-judge',
    title: '逆转裁判官',
    author: '文度延',
    genre: '律政悬疑',
    tags: ['律政', '推理', '反转'],
    rating: 9.4,
    popularity: 87,
    status: '连载中',
    chapters: 102,
    year: '2021',
    cover: 'https://readdy.ai/api/search-image?query=legal%20thriller%20webtoon%20manhwa%20cover%2C%20confident%20female%20judge%20with%20gavel%20in%20courtroom%20gavel%20light%2C%20serious%20amber%20and%20charcoal%20palette%2C%20clean%20dramatic%20background&width=600&height=800&seq=comic-12&orientation=portrait',
    summary: '天才女法官专挑"铁案"再审，在证据链中抽丝剥茧，为冤屈者讨回公道。',
    intro: '首尔地方法院的王牌法官韩秀珍，专接别人不敢碰的疑难冤案。每一次翻案都如同在刀尖上行走——既要面对舆论压力，也要对抗藏在司法系统深处的黑手。高智商律政博弈与层层反转，几乎每一话都让人拍案叫绝。',
    highlights: ['律政博弈烧脑过瘾', '案件设计精巧严谨', '正义主题热血感动'],
  },
  {
    id: 'youth-baseball',
    title: '青春棒球部',
    author: '权敏英',
    genre: '运动热血',
    tags: ['棒球', '青春', '热血'],
    rating: 9.1,
    popularity: 84,
    status: '连载中',
    chapters: 156,
    year: '2018',
    cover: 'https://readdy.ai/api/search-image?query=sports%20webtoon%20manhwa%20cover%2C%20high%20school%20baseball%20team%20on%20field%20at%20golden%20hour%2C%20dynamic%20action%20pose%2C%20warm%20sunset%20orange%20palette%2C%20energetic%20clean%20background&width=600&height=800&seq=comic-13&orientation=portrait',
    summary: '一群垫底高中棒球少年，怀揣甲子园梦想在汗水与友情中逆风成长。',
    intro: '全校人数不足三百人的"石川高中"，棒球部却立志要打进全国大赛。没有明星选手、没有资金支持，只有一群莽撞少年和一位曾经失意的教练。他们用一场场不被看好的比赛，书写最纯粹的青春与热血。运动分镜张力十足，人物成长线动人。',
    highlights: ['热血运动分镜炸裂', '角色成长线饱满', '青春友情催泪'],
  },
  {
    id: 'detective-cat',
    title: '侦探事务所的猫',
    author: '金旻序',
    genre: '推理日常',
    tags: ['推理', '治愈', '单元'],
    rating: 9.2,
    popularity: 89,
    status: '连载中',
    chapters: 88,
    year: '2023',
    cover: 'https://readdy.ai/api/search-image?query=mystery%20webtoon%20manhwa%20cover%2C%20intelligent%20cat%20in%20detective%20office%20with%20magnifying%20glass%2C%20cozy%20bookshop%20warm%20lighting%2C%20cream%20and%20amber%20palette%2C%20charming%20clean%20background&width=600&height=800&seq=comic-14&orientation=portrait',
    summary: '经营侦探事务所的年轻人和一只会推理的猫，联手侦破都市里的奇案与心事。',
    intro: '在首尔巷弄深处，有一家总是贴着"营业中"却鲜有客人光顾的侦探事务所。事务所的合伙人，是一只名叫"福尔摩斯"的橘猫，和它那心思缜密却懒散的人类搭档。他们接手的都是些不惊心动魄却直抵人心的小案子——找一只走失的猫、揭穿一场温柔的谎言。推理与治愈并重，暖到心里。',
    highlights: ['单元案件温柔治愈', '猫设讨喜圈粉无数', '都市人情味浓厚'],
  },
  {
    id: 'twin-princess',
    title: '王座之影：双生王女',
    author: '朴夏琳',
    genre: '宫廷奇幻',
    tags: ['宫廷', '权谋', '双女主'],
    rating: 9.3,
    popularity: 92,
    status: '连载中',
    chapters: 76,
    year: '2024',
    cover: 'https://readdy.ai/api/search-image?query=royal%20fantasy%20webtoon%20manhwa%20book%20cover%2C%20two%20twin%20princesses%20with%20crown%20in%20ornate%20palace%20gold%20and%20crimson%20light%2C%20regal%20dramatic%20digital%20painting%2C%20clean%20rich%20background&width=600&height=800&seq=comic-15&orientation=portrait',
    summary: '双生王女一明一暗，为守护彼此与王座背后的真相，在宫廷权谋中相互扶持。',
    intro: '王国的双生王女，一个耀眼如朝阳，一个幽微似暗影。她们从小被刻意分开抚养，只因预言中"王座之下，双子相残"。然而当朝中暗流涌动、真正的危机逼近时，姐妹俩决定联手对抗宿命，揭开王座背后的秘密。华美的宫廷场景、细腻的情感与步步为营的权谋交织，令人上头。',
    highlights: ['宫廷画风华丽养眼', '双女主羁绊动人', '权谋反转不断'],
  },
];

export const genres: string[] = [
  '都市恋爱',
  '奇幻战斗',
  '校园魔幻',
  '职场现实',
  '末日生存',
  '古风武侠',
  '科幻恋爱',
  '美食日常',
  '科幻冒险',
  '灵异悬疑',
  '热血搞笑',
  '律政悬疑',
  '运动热血',
  '推理日常',
  '宫廷奇幻',
];

export type RankingType = 'popularity' | 'rating' | 'must-read';

export interface RankingMeta {
  type: RankingType;
  label: string;
  subtitle: string;
  description: string;
}

export const rankingMeta: Record<RankingType, RankingMeta> = {
  popularity: {
    type: 'popularity',
    label: '人气榜',
    subtitle: '当下最热门韩漫 · 按热度实时排序',
    description: '聚合全站读者追更热度，动态呈现当下最值得追的韩国漫画。榜单实时更新，帮你在海量作品里快速锁定人气之作。',
  },
  rating: {
    type: 'rating',
    label: '评分榜',
    subtitle: '高分韩漫 · 口碑与质量的代名词',
    description: '由资深读者与编辑共同评定的高分韩国漫画榜单，每一部都经过口碑与质量的双重检验，闭眼入不踩雷。',
  },
  'must-read': {
    type: 'must-read',
    label: '必看榜',
    subtitle: '入坑必读 · 韩漫经典入门清单',
    description: '为刚刚入坑的读者准备的韩漫必看清单，涵盖各类型代表作，是快速建立韩漫审美的入门首选。',
  },
};

export function getRankedComics(type: RankingType): Comic[] {
  const list = [...comics];
  if (type === 'popularity') {
    return list.sort((a, b) => b.popularity - a.popularity);
  }
  if (type === 'rating') {
    return list.sort((a, b) => b.rating - a.rating);
  }
  // must-read: 综合评分+人气
  return list.sort((a, b) => b.rating * 0.6 + b.popularity * 0.4 - (a.rating * 0.6 + a.popularity * 0.4));
}

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getRelated(comic: Comic, count = 3): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id)
    .sort((a, b) => {
      const scoreA = a.tags.filter((t) => comic.tags.includes(t)).length;
      const scoreB = b.tags.filter((t) => comic.tags.includes(t)).length;
      if (scoreB !== scoreA) return scoreB - scoreA;
      return b.popularity - a.popularity;
    })
    .slice(0, count);
}